import { inject } from "@angular/core";
import { CanMatchFn, Router } from "@angular/router";
import { AuthService } from "../services";

export const userGuestCanMatchGuard: CanMatchFn = () => {
    const authService = inject(AuthService);
    const router = inject(Router);

    if (!authService.isUserAuthenticated()) {
        return true;
    }

    return router.createUrlTree(["/home"]);
};
